export class CrowdStrike {
  constructor(private readonly baseUrl: string, private readonly clientId: string, private readonly clientSecret: string) {}

  getBaseUrl() {
    return this.baseUrl;
  }

  getClientId() {
    return this.clientId;
  }

  getClientSecret() {
    return this.clientSecret;
  }
}
